import React, { Component, Fragment } from 'react';
import { startCase } from 'lodash';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import AddIcon from '@material-ui/icons/Add';
import BankIcon from '@material-ui/icons/AccountBalance';
import CardIcon from '@material-ui/icons/CreditCard';
import DeleteIcon from '@material-ui/icons/Delete';
import ContentAdd from '@material-ui/icons/Add';
import { withStyles } from '@material-ui/core/styles';
import { isMobile } from 'helpers/detect-mobile';
import CheckIcon from '@material-ui/icons/Check';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import {
  injectIntl,
  SmartDialog,
} from 'components';

const styles = theme => ({
  actionBtn: {
    backgroundColor: '#448fe4',
    borderRadius: 5,
    textTransform: 'none',
  },
  actionBtnLabel: {
    color: 'white',
    fontSize: 14,
    fontWeight: 500,
  },
  actionPrePackBtn: {
    backgroundColor: '#448fe4',
    borderRadius: 5,
    marginLeft: '15px',
    textTransform: 'none',
  },
  plus: {
    color: '#FFF',
    fontSize: '18px',
    fontWeight: 600,
  },
  plusIcon: {
    display: 'inline-block',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  plusWord: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'inline-block',
    },
  },
  addBtnLabel: { color: '#fff' },
  btnLabel: {
    display:'flex',
    alignItems: 'center',
    marginLeft:'10px',
    marginRight: '10px',
  }
});

class ViewPaymentDetailDialog extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onAddBankAccount: PropTypes.func.isRequired,
    onAddCard: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onDeletePaymentSource: PropTypes.func.isRequired,
    onSetDefaultPaymentSource: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    paymentDetail: PropTypes.shape({}),
    title: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
    classes: PropTypes.shape({}).isRequired,
  };

  static defaultProps = {
    paymentDetail: null,
  };

  renderCardBlockMobile = () => {
    const {
      formatMessage,
      paymentDetail,
      onAddCard,
      onDeletePaymentSource,
      onSetDefaultPaymentSource,
      classes,
    } = this.props;
    const cards = paymentDetail ? paymentDetail.sources.data.filter(s => s.object === 'card') : [];
    return (
      <div className="payment-type-block">
        <div className="payment-type-title">
          <h5 style={{marginBottom:'0px'}}>{formatMessage('Cards')}</h5>
          <Button
            className="no-line-height"
            classes={{ root: classes.addBtn, label: classes.addBtnLabel }}
            mini
            onClick={onAddCard}
            variant="fab"
            color="primary"
          >
            <ContentAdd />
          </Button>
        </div>
        <hr></hr>
        {cards.length > 0 ? cards.map(s => (
          <Paper key={s.id} className="payment-method">
            <div className="payment-type-title">
              <span className="payment-type"  style={{width:'max-content'}}>
                <CardIcon style={{ verticalAlign: 'top' }} />
                {s.brand}&nbsp;
              </span>
              <span>
                {`****${s.last4}`}
              </span>&nbsp;&nbsp;
              {/* <Chip
                icon={<CheckIcon style={{color:'white'}} />}
                style={{
                  background: 'green',
                  color: 'white',
                }}
                size="small"
              /> */}
              <CheckCircleIcon  style={{
                  color: 'green',
                }} />
            </div>
            <div className="payment-type-title">
              {paymentDetail.default_source === s.id ? (
                <Chip
                  color="primary"
                  label="Default"
                  style={{
                    height: '25px',
                  }}
                />)
              : (
                <Button
                  color="primary"
                  onClick={() => onSetDefaultPaymentSource(s)}
                  variant="text"
                  style={{
                    padding: '0px',
                  }}
                >
                  {formatMessage('Set As Default')}
                </Button>
              )}
              <Button
                color="default"
                onClick={() => onDeletePaymentSource(s)}
                variant="text"
                style={{
                  padding: '0px',
                }}
              >
                <DeleteIcon />
              </Button>
            </div>
          </Paper>
        )) : (<h6>{formatMessage('No Card Added.')}</h6>)}
      </div>
    );
  };


  renderCardBlock = () => {
    const {
      formatMessage,
      paymentDetail,
      onAddCard,
      onDeletePaymentSource,
      onSetDefaultPaymentSource,
      classes,
    } = this.props;
    const cards = paymentDetail ? paymentDetail.sources.data.filter(s => s.object === 'card') : [];
    return (
      <div className="payment-type-block">
        <div className="payment-type-title">
          <h5>{formatMessage('Cards')}</h5>
          <Button
            onClick={onAddCard}
            variant="contained"
          >
            {formatMessage('Add Card')}
            <AddIcon />
          </Button>
       
        </div>
        {cards.length > 0 ? cards.map(s => (
          <Paper key={s.id} className="payment-method">
            <div className="payment-type-title">
              <span className="payment-type">
                <CardIcon style={{ verticalAlign: 'top' }} />
                {s.brand}&nbsp;
              </span>
              <span>
                {`****${s.last4} ${s.exp_month}/${s.exp_year}`}
              </span>&nbsp;&nbsp;
              <Chip
                label="Verified"
                style={{
                  background: 'green',
                  color: 'white',
                }}
              />
            </div>
            <div className="payment-type-title">
              {paymentDetail.default_source === s.id ? (
                <Chip
                  color="primary"
                  label="Default"
                />)
              : (
                <Button
                  color="primary"
                  onClick={() => onSetDefaultPaymentSource(s)}
                  variant="text"
                >
                  {formatMessage('Set As Default')}
                </Button>
              )}
              <Button
                color="secondary"
                onClick={() => onDeletePaymentSource(s)}
                variant="text"
              >
                {formatMessage('Delete')}
                <DeleteIcon />
              </Button>
            </div>
          </Paper>
        )) : (<h6>{formatMessage('No Card Added.')}</h6>)}
      </div>
    );
  };

  renderBankBlockMobile = () => {
    const {
      onAddBankAccount,
      onDeletePaymentSource,
      onSetDefaultPaymentSource,
      paymentDetail,
      formatMessage,
      classes,
    } = this.props;
    const bankAccounts = paymentDetail ? paymentDetail.sources.data.filter(s => s.object === 'bank_account') : [];
    return (
      <div className="payment-type-block">
        <div className="payment-type-title">
          <h5 style={{marginBottom:'0px'}}>{formatMessage('Bank accounts')}</h5>
          <Button
            className="no-line-height"
            classes={{ root: classes.addBtn, label: classes.addBtnLabel }}
            mini
            onClick={onAddBankAccount}
            variant="fab"
            color="primary"
          >
            <ContentAdd />
          </Button>
        </div>
        <hr></hr>
        {bankAccounts.length > 0 ? bankAccounts.map(s => (
          <Paper key={s.id} className="payment-method">
            <div className="payment-type-title">
              <span className="payment-type" style={{width:'max-content'}}>
                <BankIcon style={{ verticalAlign: 'top' }} />
                {s.bank_name}
              </span>&nbsp;
              <span>
                {`****${s.last4} ${s.currency}`}
              </span>&nbsp;&nbsp;
              <Chip
                label={startCase(s.status.replace('new', 'pending'))}
                style={{
                  background: s.status === 'verified' ? 'green' : 'red',
                  color: 'white',
                }}
              />
            </div>
            <div className="payment-type-title">
              {paymentDetail.default_source === s.id ? (
                <Chip
                  color="primary"
                  label="Default"
                />
              ) : (
                <Button
                  color="primary"
                  onClick={() => onSetDefaultPaymentSource(s)}
                  variant="text"
                >
                  {formatMessage('Set As Default')}
                </Button>
              )}
              <Button
                color="secondary"
                onClick={() => onDeletePaymentSource(s)}
                variant="text"
              >
                <DeleteIcon />
              </Button>
            </div>
          </Paper>
        )) : <h6>{formatMessage('No Bank Account Added.')}</h6>}
      </div>
    );
  };

  renderBankBlock = () => {
    const {
      onAddBankAccount,
      onDeletePaymentSource,
      onSetDefaultPaymentSource,
      paymentDetail,
      formatMessage,
    } = this.props;
    const bankAccounts = paymentDetail ? paymentDetail.sources.data.filter(s => s.object === 'bank_account') : [];
    return (
      <div className="payment-type-block">
        <div className="payment-type-title">
          <h5>{formatMessage('Bank accounts')}</h5>
          <Button
            onClick={onAddBankAccount}
            variant="contained"
          >
            {formatMessage('Add Bank Account')}
            <AddIcon />
          </Button>
        </div>
        {bankAccounts.length > 0 ? bankAccounts.map(s => (
          <Paper key={s.id} className="payment-method">
            <div className="payment-type-title">
              <span className="payment-type">
                <BankIcon style={{ verticalAlign: 'top' }} />
                {s.bank_name}
              </span>&nbsp;
              <span>
                {`****${s.last4} ${s.currency}`}
              </span>&nbsp;&nbsp;
              <Chip
                label={startCase(s.status.replace('new', 'pending'))}
                style={{
                  background: s.status === 'verified' ? 'green' : 'red',
                  color: 'white',
                }}
              />
            </div>
            <div className="payment-type-title">
              {paymentDetail.default_source === s.id ? (
                <Chip
                  color="primary"
                  label="Default"
                />
              ) : (
                <Button
                  color="primary"
                  onClick={() => onSetDefaultPaymentSource(s)}
                  variant="text"
                >
                  {formatMessage('Set As Default')}
                </Button>
              )}
              <Button
                color="secondary"
                onClick={() => onDeletePaymentSource(s)}
                variant="text"
              >
                <DeleteIcon />
              </Button>
            </div>
          </Paper>
        )) : <h6>{formatMessage('No Bank Account Added.')}</h6>}
      </div>
    );
  };

  render() {
    const {
      loading,
      onClose,
      open,
      title,
    } = this.props;

    return (
      <SmartDialog
        onClose={onClose}
        open={open}
        title={title}
      >
        <div className="view-payment-detail-dialog">
        { isMobile ? ( 
          <Fragment>
            {this.renderCardBlockMobile()}
            {this.renderBankBlockMobile()}
            {loading && (
              <CircularProgress className="loader" />
            )}
          </Fragment>
        ) : (
          <Fragment>
            {this.renderCardBlock()}
            {this.renderBankBlock()}
            {loading && (
              <CircularProgress className="loader" />
            )}
          </Fragment>
        ) }
        </div>
      </SmartDialog>
    );
  }
}

const wrappedViewPaymentDetailDialog = injectIntl(ViewPaymentDetailDialog);
wrappedViewPaymentDetailDialog.displayName = 'ViewPaymentDetailDialog';

export default withStyles(styles)(wrappedViewPaymentDetailDialog);
